import api from '@/services/api';
import type { Service } from '../types/services.types';
interface ServicesApiResponse {
    data: Service[]; // Raw API data
}
interface FetchServicesParams {
    product_id?: string;
    make_id?: string;
    model_id?: string;
    derivative_id?: string;
}

const smrPath = '/smr';

export const fetchServices = async (params: FetchServicesParams = {}): Promise<Service[]> => {
    // Build query parameters, only including non-empty values
    const queryParams = new URLSearchParams();

    if (params.make_id) queryParams.append('make_id', params.make_id);
    if (params.model_id) queryParams.append('model_id', params.model_id);
    if (params.derivative_id) queryParams.append('derivative_id', params.derivative_id);

    const queryString = queryParams.toString();
    const url = `${smrPath}/products/${params.product_id}/services${queryString ? `?${queryString}` : ''}`;

    const response = await api.get<ServicesApiResponse>(url);

    return response.data.data;
};
